import React from "react"
import * as styles from "./Navbar.module.css"
import DeviceSize from "./DeviceSize"
import NavLinks from "./NavLinks"

import { useMediaQuery } from "react-responsive"
import MobileNavLinks from "./MobileNavLinks"
import { Link } from "gatsby"
const Navbar = props => {
  const isMobile = useMediaQuery({ maxWidth: DeviceSize.mobile })
  return (
    <div className={styles.nav_container}>
      <div className={styles.wrapper}>
        <div className={styles.left_section}>
          <Link href="/">
            <img alt="logo" src="/logo.png" width="80px" />
          </Link>
        </div>
        <div className={styles.right_section}>
          {!isMobile && <NavLinks />}
          {isMobile && <MobileNavLinks />}
        </div>
      </div>
    </div>
  )
}
export default Navbar
